// model
import {IInsurance} from "@/model/Insurance/Insurance"
import {IInsuranceFamily} from "@/model/InsuranceFamily/InsuranceFamily"
import ParticipantInsuranceFamily from "@/model/InsuranceFamily/ParticipantInsuranceFamily"
import GlobalInsuranceFamily from "@/model/InsuranceFamily/GlobalInsuranceFamily"
import GlobalInsurance, {IGlobalInsurance} from "@/model/Insurance/GlobalInsurance"
import ParticipantInsurance, {IParticipantInsurance} from "@/model/Insurance/ParticipantInsurance"
import InsuranceContent, {IInsuranceContent} from "@/model/Content/InsuranceContent"

import { InsuranceQuote, ServiceContent } from "@requests"


export interface IInsuranceFactory {}


class InsuranceFactory implements IInsuranceFactory {

    public static createInsurance(
        quoteObj: InsuranceQuote, 
        contentObj: ServiceContent, 
        insuranceFamily: IInsuranceFamily
    ): IInsurance {
        // create content object
        const insuranceContent: IInsuranceContent = new InsuranceContent(contentObj?.nameCommercial, "", "", contentObj?.link)
        if (insuranceFamily instanceof ParticipantInsuranceFamily) return InsuranceFactory.createParticipantInsurance(quoteObj, insuranceContent)
        if (insuranceFamily instanceof GlobalInsuranceFamily) return InsuranceFactory.createGlobalInsurance(quoteObj, insuranceContent)
        throw new Error(`insuranceFamily type of ${insuranceFamily.constructor.name} is not supported`)
    }

    
    private static createParticipantInsurance(
        quoteObj: InsuranceQuote, 
        insuranceContent: IInsuranceContent, 
    ) {
        const insurance: IParticipantInsurance = new ParticipantInsurance(
            quoteObj.id,
            quoteObj.quantity,
            quoteObj.startDate,
            quoteObj.endDate,
        )
        if (quoteObj.travellers) {
            insurance.setQuoteTravellers(quoteObj.travellers)
            if (!quoteObj.totalPrice) throw new Error("insurance must have totalPrice")
            const totalPrice = Number(quoteObj.totalPrice)
            const quantity = Number(quoteObj.quantity)
            const quoteTravellers = quoteObj.travellers
            quoteObj.travellers.forEach((travellerObj) => {
                if (quantity) {
                    insurance.setTotalPriceByTravellerOrAccomodationId(travellerObj.id, totalPrice / quantity)
                } else {
                    insurance.setTotalPriceByTravellerOrAccomodationId(travellerObj.id, totalPrice / quoteTravellers.length)
                }
            })
        }
        insurance.setBaseInsuranceQuoteObject(quoteObj)
        insurance.setInsuranceContent(insuranceContent)
        insuranceContent.setInsurance(insurance)
        return insurance
    }


    private static createGlobalInsurance(
        quoteObj: InsuranceQuote, 
        insuranceContent: IInsuranceContent, 
    ) {
        const insurance: IGlobalInsurance = new GlobalInsurance(
            quoteObj.id,
            quoteObj.quantity,
            quoteObj.startDate,
            quoteObj.endDate,
        )
        insurance.setIncluded(!!quoteObj.included)
        insurance.setSelected(!!quoteObj.selected)
        quoteObj.totalPrice && insurance.setTotalPrice(quoteObj.totalPrice)
        insurance.setBaseInsuranceQuoteObject(quoteObj)
        insurance.setInsuranceContent(insuranceContent)
        insuranceContent.setInsurance(insurance)
        return insurance
    }

}

export default InsuranceFactory